import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { UserAvatar } from '@ztechapps/webui.input'
import { AppVersion } from '@ztechapps/webui.page'
import { DashboardLockToggle } from '@ztechapps/webui.dashboard'
import { useHistory, useUser } from '@ztechapps/common.hook'
import { routesDef } from '../../config/routes'
import { ToggleColorModeDropdownItem } from './ToggleColorModeDropdownItem'
import styles from './Profile.module.scss'

// Profile dropdown — trimmed to what QuickScore ships (no Utilities/
// ClearAllLocalSettings, unlike the PanelPunches admin this mirrors).
export const Profile = () => {
  const { user, logout } = useUser()
  const history = useHistory()
  const name = user?.profile?.name ?? ''
  const email = user?.profile?.email ?? ''

  return (
    <Dropdown className="nav-item pe-3" align="end">
      <Dropdown.Toggle className={styles.toggle} as="div">
        <UserAvatar profile={user?.profile} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>
          <div className="fw-bold">{name}</div>
          <div>{email}</div>
          <AppVersion />
        </Dropdown.Header>

        <Dropdown.Divider />
        <ToggleColorModeDropdownItem />
        {/* Opens the Settings section (Organization → Users). */}
        <Dropdown.Item onClick={() => history.push(routesDef.SettingsPage.path)}>
          <HorizontalStack gap={1}>
            <Icon name="gear" />
            <span>Settings</span>
          </HorizontalStack>
        </Dropdown.Item>
        <DashboardLockToggle />
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => logout()}>
          <HorizontalStack gap={1}>
            <Icon name="sign-out" /> <span>Logout</span>
          </HorizontalStack>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
